import request from '../utils/request';

export function exchangeTokens(oneTimeToken) {
    const url = `/auth/accesstoken?token=${oneTimeToken}`;
    return request(url);
}


// WEBPACK FOOTER //
// ./src/services/authAPI.js